import { Amplify } from 'aws-amplify'
import {
  signIn as amplifySignIn,
  signOut as amplifySignOut,
  signUp as amplifySignUp,
  getCurrentUser,
  fetchAuthSession,
  confirmSignUp as amplifyConfirmSignUp,
  resendSignUpCode,
  confirmSignIn,
} from 'aws-amplify/auth'

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    },
  },
})

// Note: Region is inferred from userPoolId format (e.g., us-east-1_xxxxx)

export async function getAccessToken(): Promise<string> {
  const session = await fetchAuthSession()
  return session.tokens?.accessToken?.toString() ?? ''
}

export async function login(email: string, password: string) {
  // Clear any existing session before signing in
  // This prevents "There is already a signed in user" error
  try {
    await amplifySignOut()
  } catch {
    // Ignore errors - user may not be signed in
  }
  return amplifySignIn({ username: email, password })
}

export async function logout() {
  return amplifySignOut()
}

export async function register(email: string, password: string) {
  return amplifySignUp({
    username: email,
    password,
    options: {
      userAttributes: {
        email,
      },
    },
  })
}

export async function confirmRegistration(email: string, code: string) {
  return amplifyConfirmSignUp({ username: email, confirmationCode: code })
}

// Export aliases for consistency
export const signUp = register
export const confirmSignUp = confirmRegistration

export async function resendConfirmationCode(email: string) {
  return resendSignUpCode({ username: email })
}

export async function completeNewPasswordChallenge(newPassword: string) {
  return confirmSignIn({ challengeResponse: newPassword })
}

export async function isAuthenticated(): Promise<boolean> {
  try {
    await getCurrentUser()
    return true
  } catch {
    return false
  }
}

export async function getCurrentUserEmail(): Promise<string | null> {
  try {
    const user = await getCurrentUser()
    return user.signInDetails?.loginId ?? null
  } catch {
    return null
  }
}
